import React from 'react';

export const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const SLA = {
  expirada: { label: 'Expirada 42h', cls: 'bg-rose-600 text-white' },
  a_expirar: { label: 'A expirar', cls: 'bg-orange-500 text-white' },
  parada: { label: 'Parada +24h', cls: 'bg-rose-100 text-rose-700' },
  aguarda_contacto: { label: 'Aguarda 1º contacto', cls: 'bg-slate-100 text-slate-700' },
  em_curso: { label: 'Em curso', cls: 'bg-sky-100 text-sky-700' },
  incontactavel: { label: 'Incontactável', cls: 'bg-orange-100 text-orange-800' },
  por_atribuir: { label: 'Por atribuir', cls: 'bg-amber-100 text-amber-800' },
  convertida: { label: 'Convertida (contrato)', cls: 'bg-emerald-600 text-white' },
  fechada_sem_contrato: { label: 'Fechada sem contrato', cls: 'bg-slate-300 text-slate-800' },
};

export const STATUS_LABEL = {
  nova: 'Nova', em_contacto: 'Em Contacto', reagendada: 'Reagendada', incontactavel: 'Incontactável', proposta: 'Proposta',
  convertida: 'Convertida', sem_interesse: 'Sem Interesse', invalida: 'Inválida',
};

export const fmtDT = (iso) => {
  if (!iso) return '—';
  try { return new Date(iso).toLocaleString('pt-PT', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }); } catch { return iso; }
};

export const Clock = ({ l }) => {
  const h = l.sla_hours_left;
  if (h === null || h === undefined) return null;
  if (l.sla === 'aguarda_contacto') return <span className="text-[11px] text-slate-500">1º contacto em {Math.max(0, Math.round(h))}h</span>;
  if (l.sla === 'em_curso' || l.sla === 'a_expirar') return <span className={`text-[11px] font-semibold ${l.sla === 'a_expirar' ? 'text-orange-600' : 'text-sky-700'}`}>⏱ faltam {Math.max(0, Math.round(h))}h</span>;
  if (l.sla === 'expirada' || l.sla === 'parada') return <span className="text-[11px] text-rose-600">há {Math.abs(Math.round(h))}h</span>;
  return null;
};

export const SlaBadge = ({ sla }) => {
  const s = SLA[sla] || { label: sla, cls: 'bg-slate-100' };
  return <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full whitespace-nowrap ${s.cls}`}>{s.label}</span>;
};

export const downloadExport = async (axios, params) => {
  const res = await axios.get(`${API_URL}/lead-mgmt/export`, { params, responseType: 'blob' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(res.data);
  a.download = `gestao_leads_${params.kind}.xlsx`;
  a.click();
};
